import { Box, Button, Container, Flex } from '@chakra-ui/react'
import { ModalContentProps, SaveType } from './interface'
import { FieldValues, useForm } from 'react-hook-form'
import { useEffect } from 'react'

function ModalContent<T extends FieldValues>({
  children,
  navigations,
  isLoadingSave,
  hasDraft,
  onSubmit,
  onBack,
  value,
  defaultValues,
}: ModalContentProps<T>) {
  const isLast =
    !navigations ||
    (navigations &&
      navigations.findIndex((elm) => elm.isActive) === navigations.length - 1)

  const hasNavigation = (navigations || []).length >= 1

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    watch,
    getValues,
    setValue,
    trigger,
    reset,
  } = useForm<T>({ defaultValues })

  useEffect(() => {
    reset(value)
  }, [value])

  return (
    <Flex flexDirection="column" h="100%">
      <Box flex={1} overflow="auto">
        <Box px={10} py={8}>
          <Container maxW={hasNavigation ? 'container.xl' : 'container.lg'}>
            <Flex alignItems="flex-start" gap={10}>
              {navigations && (
                <Box
                  position="sticky"
                  top={8}
                  borderRadius="8px"
                  boxShadow="rgba(0, 0, 0, 0.08) 0px 0px 11px, rgba(0, 0, 0, 0.03) 0px 2px 2px"
                  backgroundColor="white"
                  maxW="280px"
                  flex={1}
                  p="24px"
                >
                  <Flex
                    borderLeft="4px solid #EEF0F0"
                    flexDirection="column"
                    gap="16px"
                  >
                    {navigations.map((elm, index) => {
                      return (
                        <Flex
                          ml="-4px"
                          gap="14px"
                          key={index}
                          fontWeight="bold"
                          color={elm.isActive ? '#4199d5' : '#A5ABAB'}
                          _before={{
                            content: '""',
                            w: '4px',
                            bgColor: elm.isActive ? '#4199d5' : 'transparent',
                            display: 'block',
                            borderRadius: '2px',
                          }}
                        >
                          {elm.label}
                        </Flex>
                      )
                    })}
                  </Flex>
                </Box>
              )}
              <Box flex={1}>
                {children({
                  register,
                  control,
                  watch,
                  errors,
                  setValue,
                  trigger,
                  getValues
                })}
              </Box>
            </Flex>
          </Container>
        </Box>
      </Box>
      <Box
        bgColor="white"
        boxShadow="0px 1px 1px rgba(0, 0, 0, 0.07), 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 4px 10px rgba(0, 0, 0, 0.05)"
        p="16px 24px"
      >
        <Container maxW={hasNavigation ? 'container.xl' : 'container.lg'}>
          <Flex justifyContent="space-between">
            <Box>
              {hasDraft && (
                <Button
                  onClick={() => {
                    handleSubmit((v) => onSubmit(v, SaveType.DRAFT))()
                  }}
                  variant="outline"
                  borderColor="#f46b35"
                  color="#f46b35"
                  isLoading={isLoadingSave}
                >
                  Save as Draft
                </Button>
              )}
            </Box>
            <Flex gap={3}>
              {onBack && (
                <Button
                  onClick={() => {
                    onBack(getValues())
                  }}
                  variant="link"
                >
                  Back
                </Button>
              )}
              <Button
                isLoading={isLoadingSave}
                onClick={() => {
                  handleSubmit((v) => onSubmit(v, SaveType.SAVE))()
                }}
              >
                {isLast ? 'Save' : 'Next'}
              </Button>
            </Flex>
          </Flex>
        </Container>
      </Box>
    </Flex>
  )
}

export default ModalContent
